import React from 'react';
import {connect} from "react-redux";
import BsFormPanel from "components/form/BsFormPanel";
import BsForm from "components/form/BsForm";
import PagePermission from "components/permission/PagePermission";
import ConfirmationModel from "components/model/ConfirmationModel";
import {sendCustomUserNotifications, sendTestCustomUserNotifications} from "core/actions/admin-actions";
import {ADMIN} from "core/utils/permissions";
import CUSTOM_USER_NOTIFICATIONS_FORM from "./custom-user-notifications-form";
import CustomUserNotificationsActions from "./CustomUserNotificationsActions";
import SendTextEmailNotificationModal from "./SendTextEmailNotificationModal";

import './CustomUserNotifications.scss';

class CustomUserNotifications extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openConfirmationWindow: false,
      sendTestEmailWindow: {
        open: false,
        email: ''
      }
    };
    this.fields = {};
  }

  handleSubmit(fields, e) {
    this.fields = fields;
    this.setState({openConfirmationWindow: true})
  }

  handleSend() {
    this.props.sendCustomUserNotifications({
      title: this.fields.title,
      body: this.fields.body
    });
    this.setState({openConfirmationWindow: false});
  }

  handleChange(fields) {
    this.fields = fields;
  }

  onHandleTestSend() {
    this.setState({
      ...this.state,
      sendTestEmailWindow: {
        ...this.state.sendTestEmailWindow,
        open: true
      }
    });
  }

  closeSendTestEmailModel() {
    this.setState({
      ...this.state,
      sendTestEmailWindow: {
        ...this.state.sendTestEmailWindow,
        open: false
      }
    });
  }

  sendTestEmailEmail(email) {
    this.setState({
      ...this.state,
      sendTestEmailWindow: {
        ...this.state.sendTestEmailWindow,
        email: email,
        open: false
      }
    });

    this.props.sendTestCustomUserNotifications({
      title: this.fields.title,
      body: this.fields.body,
      email: email
    });
  }

  render() {
    const formConfig = {
      ...CUSTOM_USER_NOTIFICATIONS_FORM
    };
    formConfig.title = {
      ...formConfig.title,
      actions: <CustomUserNotificationsActions onHandleTestSend={this.onHandleTestSend.bind(this)}/>,
    }

    const data = {
      title: '',
      body: ''
    };

    return (
      <div className="custom-user-notifications">
        <BsFormPanel size="l">
          <PagePermission anonymous={false} permission={ADMIN}/>
          <ConfirmationModel
            open={this.state.openConfirmationWindow}
            message="custom_user_notifications.confirmation_message"
            handleClose={() => this.setState({openConfirmationWindow: false})}
            handleApply={this.handleSend.bind(this)}
          />
          <SendTextEmailNotificationModal
            open={this.state.sendTestEmailWindow.open}
            email={this.state.sendTestEmailWindow.email}
            handleClose={this.closeSendTestEmailModel.bind(this)}
            handleSubmit={this.sendTestEmailEmail.bind(this)}
          />

          <BsForm
            config={formConfig}
            formData={data}
            onHandleSubmit={this.handleSubmit.bind(this)}
            onHandleChange={this.handleChange.bind(this)}
          />
        </BsFormPanel>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendCustomUserNotifications: (data) => {
      dispatch(sendCustomUserNotifications(data));
    },
    sendTestCustomUserNotifications: (data) => {
      dispatch(sendTestCustomUserNotifications(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomUserNotifications);
